module.exports = __webpack_public_path__ + "media/images/icons/filled/down-square-b08c0a0858a412c9d031e2097fb90dbc.svg";